/* ============================================================
   Nakasone Kojiya Custom Scripts
   Southern Island Fermented Wellness Shop

   Modules:
   1. Lazy load fade-in (Lozad-style)
   2. Section reveal animation
   3. Sticky header shadow
   4. Smooth scroll
   5. Cart button feedback
   6. Back-to-top button
   7. Hero carousel (autoplay, dots, swipe)
   8. Category tab accordion
   9. Product carousel scroll
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ============================================================
     1. Lazy Load Fade-in (Tamachan: Lozad pattern)
     ============================================================ */
  var fadeEls = document.querySelectorAll('.fade-in');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('loaded');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '200px 0px' });
    fadeEls.forEach(function(el) { fadeObserver.observe(el); });
  } else {
    fadeEls.forEach(function(el) { el.classList.add('loaded'); });
  }

  /* ============================================================
     2. Section Reveal Animation
     ============================================================ */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el) { revealObserver.observe(el); });
  }

  /* ============================================================
     3. Sticky Header Shadow
     ============================================================ */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var headerH = header.offsetHeight;
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > headerH) {
        header.style.boxShadow = '0 1px 8px rgba(44,24,16,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ============================================================
     4. Smooth Scroll (anchor links)
     ============================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = document.querySelector('.header-wrapper');
        var top = target.getBoundingClientRect().top + window.pageYOffset - (offset ? offset.offsetHeight : 0);
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ============================================================
     5. Cart Button Feedback
     ============================================================ */
  // Cart status belongs to the submitting form after its real response.
  // Do not show premature success or replace the button's child elements.

  /* ============================================================
     6. Back-to-Top Button
     ============================================================ */
  var topBtn = document.createElement('button');
  topBtn.className = 'back-to-top';
  topBtn.innerHTML = '&#9650;';
  topBtn.setAttribute('aria-label', 'Back to top');
  topBtn.style.cssText = 'position:fixed;bottom:80px;right:20px;width:40px;height:40px;background:rgba(255,255,255,0.9);border:1px solid #E8DFD0;color:#2C1810;font-size:14px;cursor:pointer;z-index:998;display:none;align-items:center;justify-content:center;transition:all 0.3s;';
  document.body.appendChild(topBtn);

  /* LINEフロートバナー(トップページのみ)との重なり回避: SPでは上に退避 */
  var lineFloat = document.getElementById('line-float');
  var adjustTopBtn = function() {
    /* 2026-10-14: AIチャットのボタン（右下・snippets/nuchi-chat.liquid）が置いた位置の上に出す */
    var chatClear = (getComputedStyle(document.documentElement).getPropertyValue('--nuchi-chat-clear') || '').replace(/\s/g, '');
    if (chatClear) {
      topBtn.style.bottom = chatClear;
      topBtn.style.right = '20px';
      return;
    }
    if (lineFloat && window.innerWidth <= 770) {
      topBtn.style.bottom = '198px';
      topBtn.style.right = '12px';
    } else {
      topBtn.style.bottom = '80px';
      topBtn.style.right = '20px';
    }
  };
  adjustTopBtn();
  window.addEventListener('resize', adjustTopBtn, { passive: true });
  window.addEventListener('nuchi-chat-placed', adjustTopBtn);

  window.addEventListener('scroll', function() {
    topBtn.style.display = window.pageYOffset > 600 ? 'flex' : 'none';
  }, { passive: true });

  topBtn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ============================================================
     7. Hero Carousel (crossfade, autoplay, dots, swipe)
     ============================================================ */
  /* 2026-07-24: id単一初期化→全カルーセル初期化(2基目が停止していたSPバグ修正) */
  document.querySelectorAll('.hero-carousel').forEach(function(carousel) {
    var slides = carousel.querySelectorAll('.hero-carousel__slide');
    var dots = carousel.querySelectorAll('.hero-carousel__dot');
    var speed = 0; /* 自動送り停止(2026-07-21代表指示・NN/g実験根拠)。復元=parseInt(carousel.dataset.autoplay)||5000 */
    var current = 0;
    var timer = null;
    var touchStartX = 0;

    function goToSlide(idx) {
      slides.forEach(function(s, i) {
        s.classList.toggle('active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === idx);
      });
      current = idx;
    }

    function nextSlide() {
      goToSlide((current + 1) % slides.length);
    }

    function prevSlide() {
      goToSlide((current - 1 + slides.length) % slides.length);
    }

    function startAutoplay() { stopAutoplay(); if (slides.length > 1 && speed > 0) {
        timer = setInterval(nextSlide, speed);
      }
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.slide));
        startAutoplay();
      });
    });

    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { nextSlide(); } else { prevSlide(); }
      }
      startAutoplay();
    }, { passive: true });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });

  /* ============================================================
     8. Category Tab Accordion
     ============================================================ */
  var tabHeaders = document.querySelectorAll('.collection-tabs__header');
  tabHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var tabId = this.dataset.tab;
      var content = document.getElementById(tabId);
      var isOpen = content && content.classList.contains('open');

      document.querySelectorAll('.collection-tabs__content').forEach(function(c) {
        c.classList.remove('open');
      });
      document.querySelectorAll('.collection-tabs__header').forEach(function(h) {
        h.classList.remove('active');
      });

      if (!isOpen && content) {
        content.classList.add('open');
        this.classList.add('active');
      }
    });
  });

  /* ============================================================
     9. Product Carousel Scroll (CSS snap + arrow buttons)
     ============================================================ */
  document.querySelectorAll('.product-carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.product-carousel__track');
    var prevBtn = carousel.querySelector('.product-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.product-carousel__arrow--next');

    if (!track) return;

    var scrollAmount = function() {
      var item = track.querySelector('.product-carousel__item');
      return item ? item.offsetWidth : 200;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  });

  /* ============================================================
     10. Mobile Drawer Menu (hamburger toggle + accordion nav)
     ============================================================ */
  var drawerToggle = document.querySelector('.header__menu-toggle');
  var drawer = document.querySelector('.header__mobile-drawer');
  var drawerClose = document.querySelector('.header__mobile-drawer-close');
  var drawerOverlay = document.querySelector('.header__mobile-drawer-overlay');

  function openDrawer() {
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (drawerToggle) {
    drawerToggle.addEventListener('click', openDrawer);
  }
  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }

  /* Drawer accordion (tamachan: 2-level category expand) */
  document.querySelectorAll('.header__mobile-nav-category-title').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sub = this.nextElementSibling;
      var isOpen = this.classList.contains('is-open');

      /* Close all other accordions */
      document.querySelectorAll('.header__mobile-nav-category-title').forEach(function(b) {
        b.classList.remove('is-open');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('is-open');
      });

      /* Toggle current */
      if (!isOpen) {
        this.classList.add('is-open');
        if (sub) sub.classList.add('is-open');
      }
    });
  });

  /* ============================================================
     11. Product Description Accordion
     ============================================================ */
  document.querySelectorAll('.product-description__tab-header').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = this.nextElementSibling;
      var isOpen = this.classList.contains('is-open');

      this.classList.toggle('is-open', !isOpen);
      if (body) body.classList.toggle('is-open', !isOpen);
    });
  });

  /* Open first tab by default */
  var firstTab = document.querySelector('.product-description__tab-header');
  if (firstTab) {
    firstTab.classList.add('is-open');
    var firstBody = firstTab.nextElementSibling;
    if (firstBody) firstBody.classList.add('is-open');
  }

  /* ============================================================
     12. Product Gallery Thumbnail Click
     ============================================================ */
  var galleryMain = document.querySelector('.product-gallery__main img');
  var galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var newSrc = this.querySelector('img').getAttribute('src');
      if (galleryMain && newSrc) {
        galleryMain.setAttribute('src', newSrc);
        galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  /* ============================================================
     13. Quantity Selector (+/- buttons)
     ============================================================ */
  document.querySelectorAll('.product-info__quantity-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.product-info__quantity-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'decrease') {
        if (val > 1) input.value = val - 1;
      } else {
        input.value = val + 1;
      }
    });
  });

  /* ============================================================
     14. FAQ Accordion
     ============================================================ */
  document.querySelectorAll('.faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = this.classList.contains('is-open');

      this.classList.toggle('is-open', !isOpen);
      if (answer) answer.classList.toggle('is-open', !isOpen);
    });
  });

  /* FAQ category tab filter */
  document.querySelectorAll('.faq-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = this.dataset.faqTab;

      document.querySelectorAll('.faq-tabs__btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      document.querySelectorAll('.faq-section').forEach(function(section) {
        if (section.dataset.faqCategory === tab) {
          section.style.display = '';
        } else {
          section.style.display = 'none';
        }
      });
    });
  });

  /* ============================================================
     15. Gift Page Tabs
     ============================================================ */
  document.querySelectorAll('.gift-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabId = this.dataset.giftTab;

      document.querySelectorAll('.gift-tabs__btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      document.querySelectorAll('.gift-tab-content').forEach(function(content) {
        content.classList.remove('active');
      });

      var target = document.getElementById(tabId);
      if (target) target.classList.add('active');
    });
  });

  /* ============================================================
     17. (廃止) Account (MyPage) Icon Injection
     ----------------------------------------------------------------
     以前はDawn標準のアカウントアイコンとは別に「マイページ」ラベル付き
     アイコンを注入していましたが、ヘッダー上で2重表示される問題があり
     2026-04-23に廃止しました。
     Dawn標準のヘッダー内アカウントアイコン（人型・ラベル無し）のみを
     使用してください。重複注入防止のため本セクションは空に保ちます。
     ============================================================ */
  /* 何もしません（no-op） */

  /* ============================================================
     16. Mobile Sticky Cart Bar (show/hide on scroll)
     ============================================================ */
  var stickyCartBar = document.getElementById('sticky-cart-bar');
  var addToCartSection = document.querySelector('.product-info__add-btn');

  if (stickyCartBar && addToCartSection) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyCartBar.classList.remove('is-visible');
        } else {
          stickyCartBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(addToCartSection);

    /* Sticky bar add-to-cart click mirrors main button */
    var stickyBtn = document.getElementById('sticky-cart-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        if (addToCartSection) addToCartSection.click();
      });
    }
  }

  /* ============================================================
     10. Product Quantity Selector (tamachan-style native select 1-10)
     ------------------------------------------------------------
     商品ページの数量入力を、1-10の選択肢を持つネイティブ<select>に置換。
     Dawnのquantity-input要素は非表示にし、<select>の値を同期する。
     ============================================================ */
  function nuchiInitQtySelect(root) {
    root = root || document;
    var MAX_QTY = 10;
    var forms = root.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function(form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;
      if (qtyInput.dataset.nuchiQtyReplaced === '1') return;
      qtyInput.dataset.nuchiQtyReplaced = '1';

      var select = document.createElement('select');
      select.className = 'nuchi-qty-select';
      select.setAttribute('aria-label', '数量');

      var inputMax = parseInt(qtyInput.getAttribute('max') || '', 10);
      var maxOpt = (!isNaN(inputMax) && inputMax > 0) ? Math.min(inputMax, MAX_QTY) : MAX_QTY;
      var currentVal = parseInt(qtyInput.value || '1', 10);
      if (isNaN(currentVal) || currentVal < 1) currentVal = 1;

      for (var i = 1; i <= maxOpt; i++) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = String(i);
        if (i === currentVal) opt.selected = true;
        select.appendChild(opt);
      }

      var wrapper = qtyInput.closest('quantity-input') || qtyInput.closest('.quantity');
      if (wrapper && wrapper.parentNode) {
        wrapper.parentNode.insertBefore(select, wrapper);
        wrapper.classList.add('nuchi-qty-hidden');
      } else {
        qtyInput.parentNode.insertBefore(select, qtyInput);
        qtyInput.classList.add('nuchi-qty-hidden');
      }

      select.addEventListener('change', function() {
        qtyInput.value = this.value;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      qtyInput.addEventListener('change', function() {
        var v = parseInt(this.value, 10);
        if (!isNaN(v) && v >= 1 && v <= maxOpt) {
          select.value = String(v);
        }
      });
    });
  }
  nuchiInitQtySelect(document);
  document.addEventListener('shopify:section:load', function(e) {
    nuchiInitQtySelect(e.target || document);
  });

  /* ============================================================
     11. Continue Shopping - return to last viewed product
     ------------------------------------------------------------
     商品ページを訪問した際にそのURLをsessionStorageに保存し、
     カートページの「買い物を続ける」リンクを直前商品URLに書換。
     ============================================================ */
  (function() {
    var KEY = 'nuchiLastProductUrl';
    var path = window.location.pathname || '';
    var isProduct = path.indexOf('/products/') === 0 || path.indexOf('/products/') > -1 && path.indexOf('/cart') === -1;
    var isCart = path === '/cart' || path.indexOf('/cart') === 0;

    if (isProduct && path.indexOf('/products/') > -1) {
      try {
        sessionStorage.setItem(KEY, window.location.pathname + window.location.search);
      } catch (e) {}
    }

    if (isCart) {
      var last = null;
      try { last = sessionStorage.getItem(KEY); } catch (e) {}
      if (last) {
        var selectors = [
          'a.nuchi-cart__continue',
          'a[data-nuchi-continue]',
          'a.cart__continue-link',
          '.cart__footer a[href="/collections/all"]',
          '.cart__continue a'
        ];
        selectors.forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(a) {
            a.setAttribute('href', last);
          });
        });
      }
    }
  })();

});
/* ============================================================
   NUCHI - Continue Shopping: Back to Previous Page (2026-05-28)
   ------------------------------------------------------------
   カート画面の「お買い物を続ける」ボタンを、カート進入前に
   閲覧していたページ（スクロール位置含む）に戻すスクリプト。

   仕組み:
     1. カート以外のページで、現在のURLとスクロール位置を
        sessionStorage に保存する
     2. カートページで「お買い物を続ける」ボタンの href を
        その保存URLに書き換える
     3. 戻った先のページで、保存していたスクロール位置に復元する

   フォールバック:
     - 保存URLがない（直接カートにアクセス等）場合は、ボタンの
       元のリンク先（通常 /collections/all）のまま動作
   ============================================================ */

(function() {
  'use strict';

  // ----------------------------------------
  // 設定
  // ----------------------------------------
  var STORAGE_URL_KEY = 'nuchi_preCartUrl';
  var STORAGE_SCROLL_KEY = 'nuchi_preCartScroll';
  var STORAGE_RESTORE_FLAG = 'nuchi_shouldRestoreScroll';

  // 「お買い物を続ける」ボタンを特定するセレクタ群
  // テーマに合わせて広めに拾う
  var CONTINUE_BTN_SELECTORS = [
    '.cart__continue-button',
    '.cart-summary__continue',
    '.cart__continue',
    'a.cart-continue',
    '[data-cart-continue-shopping]',
    'a[href="/collections/all"]',
    'a[href*="/collections/"][href$="all"]'
  ].join(', ');

  var isCartPage = /^\/cart/.test(window.location.pathname);

  // ----------------------------------------
  // 1. カート以外のページでURL＋スクロール位置を保存
  // ----------------------------------------
  if (!isCartPage) {
    var saveBrowseState = function() {
      try {
        sessionStorage.setItem(STORAGE_URL_KEY, window.location.href);
        sessionStorage.setItem(STORAGE_SCROLL_KEY, String(window.scrollY || 0));
      } catch (e) {
        // ストレージ無効時は何もしない
      }
    };

    // 初回保存（URL）
    saveBrowseState();

    // スクロールは負荷軽減のためデバウンス
    var scrollTimer;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(saveBrowseState, 150);
    }, { passive: true });

    // ページ離脱時にも保存
    window.addEventListener('beforeunload', saveBrowseState);
    window.addEventListener('pagehide', saveBrowseState);
  }

  // ----------------------------------------
  // 2. カートページのボタン書き換え
  // ----------------------------------------
  if (isCartPage) {
    var bindContinueButtons = function() {
      var btns = document.querySelectorAll(CONTINUE_BTN_SELECTORS);
      if (!btns.length) return;

      var preCartUrl = sessionStorage.getItem(STORAGE_URL_KEY);
      if (!preCartUrl) return;

      // 現在のオリジンと同じURLのみ書き換え（外部リンク対策）
      try {
        var url = new URL(preCartUrl);
        if (url.origin !== window.location.origin) return;
        // カート自身に戻るのは防ぐ
        if (/^\/cart/.test(url.pathname)) return;
      } catch (e) {
        return;
      }

      btns.forEach(function(btn) {
        btn.setAttribute('href', preCartUrl);
        btn.addEventListener('click', function() {
          try {
            sessionStorage.setItem(STORAGE_RESTORE_FLAG, '1');
          } catch (e) {}
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindContinueButtons);
    } else {
      bindContinueButtons();
    }

    // 動的レンダリング（カートドロワー再描画など）にも対応
    var observer = new MutationObserver(function() {
      bindContinueButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ----------------------------------------
  // 3. カート以外のページに戻ってきた時、スクロール位置を復元
  // ----------------------------------------
  if (!isCartPage) {
    try {
      var shouldRestore = sessionStorage.getItem(STORAGE_RESTORE_FLAG) === '1';
      if (shouldRestore) {
        sessionStorage.removeItem(STORAGE_RESTORE_FLAG);
        var savedScroll = parseInt(sessionStorage.getItem(STORAGE_SCROLL_KEY) || '0', 10);
        if (savedScroll > 0) {
          // ページ要素が完全に読み込まれてから複数回トライ
          var doScroll = function() {
            window.scrollTo({ top: savedScroll, behavior: 'instant' });
          };
          // ブラウザの自動スクロール復元を上書きするため少し待つ
          setTimeout(doScroll, 50);
          setTimeout(doScroll, 200);
          setTimeout(doScroll, 500);
        }
      }
    } catch (e) {}
  }

})();
